import { offerBaseModel } from './crud';

export * from './types';

export const useOffersById = offerBaseModel.fetchById();
export const useOffersByIds = offerBaseModel.fetchByIds();
export const useOffersMany = offerBaseModel.fetchMany();
export const useOffersCount = offerBaseModel.count();
export const useOffersManyInfiniteQuery = offerBaseModel.fetchPaginated();
export const useOffersUpdateOne = offerBaseModel.edit();
export const useOffersCreateOne = offerBaseModel.create();
export const useOffersRemoveOne = offerBaseModel.delete();
export const useOffersRemoveByIds = offerBaseModel.deleteByIds();

export const useOffersByIdV2 = offerBaseModel.fetchByIdV2();
export const useOffersByIdsV2 = offerBaseModel.fetchByIdsV2();
export const useOffersManyV2 = offerBaseModel.fetchManyV2();
export const useOffersCountV2 = offerBaseModel.countV2();
export const useOffersManyInfiniteQueryV2 = offerBaseModel.fetchPaginatedV2();
export const useOffersUpdateOneV2 = offerBaseModel.editV2();
export const useOffersCreateOneV2 = offerBaseModel.createV2();
export const useOffersRemoveOneV2 = offerBaseModel.deleteV2();
export const useOffersRemoveByIdsV2 = offerBaseModel.deleteByIdsV2();

// New names based on Mongoose queries
export const useOfferById = offerBaseModel.fetchById();
export const useOfferByIds = offerBaseModel.fetchByIds();
export const useOfferMany = offerBaseModel.fetchMany();
export const useOfferCount = offerBaseModel.count();
export const useOfferPagination = offerBaseModel.fetchPaginated();
export const useOfferUpdateOne = offerBaseModel.edit();
export const useOfferCreateOne = offerBaseModel.create();
export const useOfferRemoveOne = offerBaseModel.delete();
export const useOfferRemoveByIds = offerBaseModel.deleteByIds();

export const useOfferByIdV2 = offerBaseModel.fetchByIdV2();
export const useOfferByIdsV2 = offerBaseModel.fetchByIdsV2();
export const useOfferManyV2 = offerBaseModel.fetchManyV2();
export const useOfferCountV2 = offerBaseModel.countV2();
export const useOfferPaginationV2 = offerBaseModel.fetchPaginatedV2();
export const useOfferUpdateOneV2 = offerBaseModel.editV2();
export const useOfferCreateOneV2 = offerBaseModel.createV2();
export const useOfferRemoveOneV2 = offerBaseModel.deleteV2();
export const useOfferRemoveByIdsV2 = offerBaseModel.deleteByIdsV2();
